import React, {useState} from 'react';
import FormNavigation, {
    defaultBack,
    defaultNext,
} from 'components/forms/context/FormNavigation';

export default function withNavigation(Component) {
    const NavigationComponent = props => {
        const [backButton, setBackButton] = useState(defaultBack);
        const [nextButton, setNextButton] = useState(defaultNext);
        const [triggerPost, setTriggerPost] = useState(false);

        return (
            <FormNavigation.Provider
                value={{
                    back: backButton,
                    next: nextButton,
                    setBackButton: config => {
                        setBackButton({
                            ...backButton,
                            ...config,
                        });
                    },
                    setNextButton: config => {
                        setNextButton({
                            ...nextButton,
                            ...config,
                        });
                    },
                    triggerPost: triggerPost,
                    setTriggerPost: value => {
                        setTriggerPost(value);
                    },
                }}
            >
                {React.createElement(Component, props)}
            </FormNavigation.Provider>
        );
    };
    NavigationComponent.displayName = `withNavigation(${
        Component?.displayName || Component?.name
    })`;

    return NavigationComponent;
}
